export class BookParameters {
  public action: string;
  public tripType: string;
  public priceSchedule: string;
  public originCity: string;
  public destinationCity: string;
  public departureDate: string;
  public departureTime: string;
  public returnDate: string;
  public returnTime: string;
  public paxCount: string;
  public searchByCabin: string;
  public cabinFareClass: string;
  public deltaOnlySearch: string;
  public deltaOnly: string;
  public go: string;
  public meetingEventCode: string;
  public refundableFlightsOnly: string;
  public nearbyAirports: string;
  public upgradeRequest: string;
  public flights: BookFlightParameter[];
  public datesFlexible: string;
  public awardTravel: string;
  public flexAirport: string;
  public isQueryParam: boolean;
  public adtCount: string;
  public gbeCount: string;
  public childCount: string;
  public infantCount: string;
  public se?: string;
  public paxcounts?: string[];
  public passengerInfo?: string;
  public mkcpgn?: string;
  public connectionCity?: string[];
  public originCities?: string[];
  public destinationCities?: string[];
  public departureDates?: string[];
  public departureTimes?: string[];
  public searchType?: string;
  public shopType?: string;
  public bookingPostVerify?: string;
  public bundled?: string;
  public schedulePrice?: string;
  public shopWithMiles?: string;
  public originCountryCode: string;
  public destinationCountryCode: string;
  public originCountryCodes?: string[];
  public destinationCountryCodes?: string[];
  public includeBasicFaresUnchecked?: boolean;
}

export class BookFlightParameter {
  public fromAirportcode: string;
  public toAirportcode: string;
  public departDate: string;
  public connectionAirport: string;
}
